const ns = "CREDENTIAL_LINE_ITEMS";
export const ERROR = `${ns}_ERROR`;
export const RECEIVE = `${ns}_RECEIVE`;
export const DELETE_LINE_ITEM = `${ns}_DELETE_LINE_ITEM`;
export const UPDATE_META = `${ns}_UPDATE_META`;
